<template>
  <b-modal id="deleteUser" size="lg" title="Eliminar usuario" hide-footer>
    <form
      @submit.prevent="submit"
      v-promise-btn="{ action: 'submit' }"
      ref="form"
    >
      <div class="container" v-if="this.usuario">
        <div class="row">
          <div class="col-12">
            <p>
              ¿Seguro deseas eliminar {{ this.usuario.nom_usuario }}
              {{ this.usuario.apellido }}?
            </p>

            <div class="w-100 d-flex justify-content-end">
              <button type="button" class="btn btn-danger" @click="volver">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary">Si!</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </b-modal>
</template>
<script>
import axios from "axios";

export default {
  name: "eliminar-usuario",
  computed: {
    usuario: {
      get() {
        return this.$store.getters["usuarios/getEliminarUsuario"];
      },
    },
  },

  methods: {
    async submit() {
      const resp = await axios.post(`/execute`, {
        method: "SEC.EliminarUsuario",
        parameters: [{ name: "id_usuario", value: this.usuario.id_usuario }],
      });

      if (resp.data.ok) {
        this.$bvModal.hide("deleteUser");

        this.$emit("update");
        this.$bvToast.toast(resp.data.message, {
          variant: "success",
        });
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
    volver() {
      this.$bvModal.hide("deleteUser");
    },
  },
};
</script>
